import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { signup } = useAuth();
    const navigate = useNavigate();

    React.useEffect(() => { document.title = "Create Account | Loomara"; }, []);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await signup(name, email, password);
        setLoading(false);
        if (res.ok) {
            toast("Welcome to the Loomara family ✨");
            navigate("/account", { replace: true });
        } else {
            toast(res.error || "Signup failed");
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center container-boutique py-16" data-testid="signup-page">
            <form onSubmit={submit} className="card-soft p-10 w-full max-w-md">
                <p className="eyebrow text-center">Join Loomara</p>
                <h1 className="font-serif text-4xl text-ink-900 text-center mt-2 mb-8">Create Account</h1>
                <div className="space-y-4">
                    <input value={name} onChange={(e)=>setName(e.target.value)} required placeholder="Full name" className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300" data-testid="signup-name" />
                    <input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" required placeholder="Email" className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300" data-testid="signup-email" />
                    <input value={password} onChange={(e)=>setPassword(e.target.value)} type="password" required minLength={6} placeholder="Password (min 6 chars)" className="w-full bg-ivory-100 rounded-xl px-4 py-3 text-sm border border-sage-300/30 focus:outline-none focus:ring-2 focus:ring-sage-300" data-testid="signup-password" />
                    <button disabled={loading} className="btn-primary w-full" data-testid="signup-submit">{loading ? "Creating…" : "Create Account"}</button>
                </div>
                <p className="text-center text-sm text-ink-500 mt-6">
                    Already have an account? <Link to="/login" className="text-sage-700 underline underline-offset-4" data-testid="link-login">Sign in</Link>
                </p>
            </form>
        </div>
    );
}
